'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 15,
    bottom: 70,
    left: 10,
    right: 20
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    // Y-axis
    yNumberOfTicks: 5,
    yAxisShift: -68,
    yAxisLabelShift: -10
  };
};
module.exports = Params;